module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "map"
    }
  }, [(!_vm.section.map) ? _c('div', {
    attrs: {
      "id": "map-cover"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mapkeyON) ? _c('mapkey', {
    attrs: {
      "light": _vm.light,
      "city": _vm.city,
      "map": _vm.map,
      "layers": _vm.currentMap,
      "section": _vm.section
    },
    on: {
      "switch-bg": _vm.switchBG,
      "remove-all": _vm.removeAll,
      "add-layer": _vm.addLayer,
      "remove-layer": _vm.removeLayer,
      "get-layers": _vm.getLayers
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "city-map",
    attrs: {
      "id": "mapbox"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25673d56"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mapbox.vue
// module id = 297
// module chunks = 1